<h1 mat-dialog-title>Delete series</h1>
<div mat-dialog-content>

    Would you like to delete selected series?    
    
</div>
<div mat-dialog-actions>
    <button mat-button (click)="deleteSeries()">Delete series</button>
    <button mat-button (click)="onNoClick()">Cancel</button>
</div>